import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import { useAppContext } from '../../../redux/slices/appContext'
import { DenaliScopeContext, DEFAULT_LABELS } from '../DenaliAnalysis/filters/DenaliScopeProvider'

const NOOP = () => {}

/**
 * Wraps children with a DenaliScopeContext that scopes blueprint queries
 * to the currently selected client. The scopeType must match a
 * scopePredicates[].scopeType on the blueprint purpose, and the
 * presentation must have scope.enabled = true.
 */
function QBPClientFilter ({ scopeType = 'Client', children }) {
  const { clientId } = useAppContext()

  const providerValue = useMemo(() => {
    if (!clientId) return null
    return {
      scopeKey: scopeType,
      scopes: [{ name: scopeType, path: [], labels: DEFAULT_LABELS }],
      selectedValues: [clientId],
      selectScopeKey: NOOP,
      selectScopeValues: NOOP
    }
  }, [clientId, scopeType])

  if (!providerValue) return null

  return (
    <DenaliScopeContext.Provider value={providerValue}>
      {children}
    </DenaliScopeContext.Provider>
  )
}

QBPClientFilter.propTypes = {
  scopeType: PropTypes.string,
  children: PropTypes.node
}

export default QBPClientFilter
